// Utility to optimize Storyblok image URLs via img2.storyblok.com
// Usage: optimizeSbImage(url, { quality: 75, width: 800 })
export function optimizeSbImage(url, opts = {}) {
  if (!url) return url;
  const { quality = 75, width } = opts;

  // Ensure https protocol
  let src = url.startsWith('//') ? `https:${url}` : url;

  try {
    const u = new URL(src);
    // Only optimize Storyblok-hosted images
    if (!u.hostname.includes('storyblok.com')) return src;

    // Build transform segment
    const transforms = [];
    if (typeof width === 'number' && width > 0) {
      // Resize by width, keep aspect ratio; using fit-in to avoid cropping
      transforms.push(`fit-in/${Math.floor(width)}x0`);
    }
    // Add quality filter
    transforms.push(`filters:quality(${Math.min(Math.max(quality, 30), 90)})`);

    // Reconstruct URL using img2 domain and prepend transforms before the original path
    const path = u.pathname.startsWith('/') ? u.pathname : `/${u.pathname}`;
    const optimized = `https://img2.storyblok.com/${transforms.join('/')}${path}`;
    return optimized;
  } catch (e) {
    return src;
  }
}
